export default "__VITE_ASSET__d09cd014__"